import { BaseService } from 'core/services';
import { FulfillmentUserRouteService } from 'common/data';

class FulfillmentUserService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new FulfillmentUserRouteService());
	}

	validateEmail(email) {
		var url = this.routeService.validateEmail(email);
		return this.apiClient.get(url);
	}
}

export default FulfillmentUserService;



// WEBPACK FOOTER //
// ./src/common/data/services/FulfillmentUserService.js